(function($) {
  $(document).ready(function() {
    var $window = $(window);
    var $htmlBody = $('html, body');
    var $bttn = $('.to-the-top');
    var $top = $("#top");
    var scrollPos = 0;

    var showHideBtn = function(){
      var currentScrollPos = $window.scrollTop();
      var shouldShowBtn = currentScrollPos <= scrollPos && currentScrollPos > $window.height() * .6;
      
      shouldShowBtn ? $bttn.addClass('show') : $bttn.removeClass('show');
      scrollPos = currentScrollPos;
    };

    $bttn.on('click', function(e){
      e.preventDefault();
      $htmlBody.animate({ scrollTop: 0 }, 'fast', function(){
        $top.focus();        
      });
    });

    $bttn.on('focus', 'a', showHideBtn)
    $window.on('scroll', showHideBtn);
  });
})(jQuery);
